import { IPagination } from "../../shared/interfaces/shared/IPagination";
import { NOTIFICATIONS_URL } from "../../utils/api/endpoints";
import { requests } from "../../utils/api/api.service";
import { IBaseModel } from "../../shared/interfaces/shared/IBase";
import { INotification } from "../../shared/interfaces/notification/INotification";

export const NotificationsService = {
  getAll: (params: IPagination): Promise<IBaseModel<INotification[]>> =>
    requests.get(`${NOTIFICATIONS_URL}/list`, params),
  getUnread: (): Promise<{ unreadNotificationsCount: number }> =>
    requests.get(`${NOTIFICATIONS_URL}/unread-count`),
};
